<template>
  <div class="machine-container">
    <div>
      <h1 class="">{{ fit20.selectTabId }} Locator's data</h1>
      <br>
      <div class="search-add-sec">
        <input type="text" placeholder="Search..." @input="filterStudios" ref="searchInput" />
        <img width="50" @click.stop.prevent="showAddStudio()"
          src="https://storage.googleapis.com/fit20app-4-acctest.appspot.com/static/icons/%2B.png" />
      </div>
    </div>

    <!-- <input type="text" placeholder="Search..." @input="filterStudios" /> -->
    <div class="machines" v-if="filteredStudios.length > 0">
      <div :class="['studios-card', { inactive: !studio.properties.active }]" v-for="studio in filteredStudios"
        :key="studio.properties.name" @click.stop.prevent="getStudio(studio.properties.name)">
        <a href="#" :id="studio.properties.name">
          <div>{{ studio.properties.name }}</div>
        </a>
      </div>
    </div>
    <!-- start edit member popup  -->
    <div class="popup-overlay" :class="{ 'remove-center': notCenter }" v-if="studioToEdit">
      <div class="edit-member" ref="content">
        <div class='popup-title flex'>
          <span>{{ studioToEdit.properties.name }}</span>
          <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="getStudio(false)" />
        </div>
        <div class="flex edit-member-body">
          <form class="session-form-container" id="admin_studio_info">
            <div class="flex edit-member-1sec">
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Zoho ID:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.dealerId" />
              </div>
              <div class="field-sec">
                <label>Name*:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.name" />
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Address:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.address" />
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Post code:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.postCode" />
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Phone:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.phone" />
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Email:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.email" />
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>image link:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.image" />
              </div>
              <div class="field-sec">
                <label>{{ !fit20.franchiseCodes.includes(fit20.selectTabId) ? 'Website link*:' : `Link to the
                  FOform*:`}}</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.website_link" />
              </div>
              <div class="field-sec">
                <label>Longitude*:</label>
                <input type="text" class="form-control" v-model="studioToEdit.geometry.coordinates[0]" />
              </div>
              <div class="field-sec">
                <label>Latitude*:</label>
                <input type="text" class="form-control" v-model="studioToEdit.geometry.coordinates[1]" />
              </div>
              <div class="field-sec">
                <label>Active:</label>
                <select id="" class="" v-model="studioToEdit.properties.active">
                  <option :value=false>NO</option>
                  <option :value=true>YES</option>
                </select>
              </div>
              <div class="field-sec"
                v-if="!studioToEdit.properties.dealerId && !fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Send email:(only if there is no Zoho ID)</label>
                <select id="" class="" v-model="studioToEdit.properties.send_email">
                  <option :value=false>NO</option>
                  <option :value=true>YES</option>
                </select>
              </div>

              <div class="field-sec">
                <!-- <label>Google map iframe:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.map" /> -->
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Address for contact block:</label>
                <textarea style="min-height: 100px;" v-model="studioToEdit.properties.address2"></textarea>
              </div>
              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Opening time:</label>
                <textarea style="min-height: 100px;" v-model="studioToEdit.properties.opening_time"></textarea>
              </div>

              <div class="field-sec" v-if="!fit20.franchiseCodes.includes(fit20.selectTabId)">
                <label>Prices per studio:</label>
                <select id="" class="" v-model="studioToEdit.properties.price_per_studio">
                  <option :value=false>NO</option>
                  <option :value=true>YES</option>
                </select>
              </div>
              <div class="field-sec" v-if="studioToEdit.properties.price_per_studio">
                <label>Solo price:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.prices.solo" />
              </div>
              <div class="field-sec" v-if="studioToEdit.properties.price_per_studio">
                <label>Duo price:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.prices.duo" />
              </div>
              <div class="field-sec" v-if="studioToEdit.properties.price_per_studio">
                <label>Flex price:</label>
                <input type="text" class="form-control" v-model="studioToEdit.properties.prices.flex" />
              </div>
            </div>
          </form>
        </div>
        <div>
          <div class="fake-div"></div>
          <div class="btn-container">
            <span :class="'fit20-btn ' + (isChanged ? 'save-btn-active' : 'save-btn-disable')"
              @click="saveStudios(newStudio);">
              Save
            </span>
          </div>
        </div>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';
export default {
  name: 'Studios',
  components: {},
  props: ["fit20"],
  data() {
    return {
      notCenter: false,
      newStudio: false,
      studios: [],
      filteredStudios: [],
      inputValue: '',
      studioToEdit: null,
      isChanged: false,
      originalStudios: [],
    };
  },
  methods: {
    showAddStudio() {
      this.newStudio = true;
      this.studioToEdit = {
        "geometry": {
          "type": "Point",
          "coordinates": []
        },
        "type": "Feature",
        "properties": {
          "dealerId": "",
          "category": "patisserie",
          "name": "",
          "address": "",
          "postCode": "",
          "phone": "",
          "email": "",
          "studios": "01",
          "icon": "./marker.png",
          "image": "",
          "website_link": "",
          "send_email": false,
          "active": true,
          "lastModified": [],
          "opening_time": "",//text area
          "address2": "", // text area
          // "map": "",
          "price_per_studio": false,
          "prices": { "solo": "", "duo": "", "flex": "", },
        }
      };
    },
    getStudio(name) {
      this.checkAlign();
      this.newStudio = false;
      if (name) {
        let studioToEdit = this.fit20.studios.find(studio => studio.properties.name == name);
        if (studioToEdit) {
          this.studioToEdit = studioToEdit;
        } else {
          this.studioToEdit = null;
        }
      } else {
        this.studioToEdit = null;
        // this.fit20.studios = JSON.parse(JSON.stringify(this.originalStudios));
      }
    },
    async saveStudios(newStudio) {
      this.checkAlign();

      if (isEqual(this.fit20.studios, this.originalStudios) && !newStudio) {
        alert('No changes to save');
        this.studioToEdit = null;
      } else if (!this.studioToEdit.properties.name) {
        alert('Name is required');
      } else if (!this.studioToEdit.properties.dealerId && !this.studioToEdit.properties.send_email && !this.fit20.franchiseCodes.includes(this.fit20.selectTabId)) {
        alert('Zoho ID or (send email) must be provided');
      } else if (!this.studioToEdit.properties.website_link) {
        alert('Website link is required');
      }
      else if (!this.studioToEdit.geometry.coordinates[0]) {
        alert('Longitude link is required');
      }
      else if (!this.studioToEdit.geometry.coordinates[1]) {
        alert('Latitude link is required');
      }
      else {
        if (!this.studioToEdit.properties.dealerId) {
          this.studioToEdit.properties.dealerId = 123;
        }

        this.studioToEdit.properties.lastModified.push({
          by: "mohammad_test@test.com",
          date: new Date(Date.now()),
          details: 'update',
        });
        if (this.studioToEdit.properties.lastModified.length > 10) {
          this.studioToEdit.properties.lastModified = this.studioToEdit.properties.lastModified.slice(-10);
        }
        if (newStudio) {
          this.fit20.studios.push(this.studioToEdit);
        }
        let data = {
          type: "FeatureCollection",
          features: this.fit20.studios,
          id: this.fit20.selectTabId
        }
        let updateBlock = await fetch(this.fit20.baseUrl + "/api/studios/" + this.fit20.user.email + "?code=" + this.fit20.selectTabId + "&accessToken=" + localStorage.getItem('access_token'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data),
        });
        //let updatedStudios = await updateBlock.json();
        if (updateBlock && !updateBlock.msg) {
          this.originalStudios = JSON.parse(JSON.stringify(this.fit20.studios));
          this.studioToEdit = null;
          this.newStudio = false;
        } else {
          this.studioToEdit = null;
          this.newStudio = false;
          alert('Something went wrong...!');
        }



      }

    },
    checkAlign() {
      const content = this.$refs.content;
      if (!content) return;
      this.notCenter = content.offsetHeight > window.innerHeight;
    },
    filterStudios(event) {
      this.inputValue = event;
      let searchWord = event.target.value.toLowerCase().trim()
      if (searchWord.length > 0) {
        this.filteredStudios =
          this.fit20.studios.filter(studio => studio.properties.name.toLowerCase().includes(searchWord));
      } else {
        this.filteredStudios = [...this.fit20.studios]
      }
    },
  },
  mounted: async function () {
    this.$nextTick(() => {
      this.checkAlign();
      window.addEventListener("resize", this.checkAlign);
    });
  },
  created: async function () {
  },
  watch: {
    'fit20.studios': {
      immediate: true, // This runs the watcher immediately on mount
      deep: true, // Watch for changes in nested properties
      handler(newVal) {
        this.inputValue = "";
        if (this.$refs.searchInput && this.$refs.searchInput.value) {
          this.$refs.searchInput.value = '';
        }

        if (!this.inputValue) {
          this.filteredStudios = [...newVal];
        }
        if (this.originalStudios.length) {
          this.originalStudios = JSON.parse(JSON.stringify(newVal));
        }
      }
    }
  }
};
</script>

<style scoped>
h1 {
  color: var(--fit20-blue);
}

.inactive {
  background-color: rgb(216, 216, 216);
}

.machine-container {
  width: 100%;
  height: 100%;
}

.search-add-sec {
  display: flex;
  justify-content: space-between;
  padding-right: 15px;
}

.search-add-sec img {
  width: 50px;
}

.machine-container input {
  border: solid 1px var(--fit20-lighter-gray);
  border-radius: 10px;
  padding: 7px 5px;
  width: 40%;
}

.machines {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-height: calc(100% - 100px);
  /* Adjust as needed */
  overflow: auto;
  margin-top: 10px;
}

.studios-card {
  display: flex;
  margin: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  width: calc(100% / 3 - 20px);
  /* min-height: 40px; */
  border-radius: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 5px;
}

.studios-card-inactive {
  background-color: var(--fit20-lighter-gray);
}

.selected {
  background-color: var(--fit20-blue);
  color: white !important;
  text-align: center;
  transition: all .8s;
}

.selected a {
  color: white !important;
}

.machine-card a {
  display: inline-block;
  width: 100%;
  height: 100%;
  /* margin-left: 10px; */
}

/* img {
  width: 35%;
  max-width: 110px;
  min-width: 70px;
  min-height: 70px;
} */
.edit-member {
  background-color: white;
  border-radius: 10px;
  width: 90%;
  /* max-height: 100%; */
  height: fit-content;
}

.edit-member-body {
  margin-top: 5px;
  padding-bottom: 10px;
  overflow: scroll;
  /* max-height: 600px; */
}

.edit-member-body>form {
  width: 100%;
  padding-left: 10px;
}

.edit-member-1sec>.field-sec {
  width: 33%;
}

.field-sec {
  margin-top: 15px;
}

.field-sec.flex>label {
  padding: 0px 0px 0px 10px;
  /* margin-left: 10px; */
}

.member-info.flex {
  flex-wrap: nowrap;
}

.session-form-container input,
.session-form-container select,
.session-form-container textarea {
  width: 95%;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.session-form-container input,
.session-form-container select {
  height: 30px;
  background-color: white;
  padding-left: 5px;
  border-radius: 5px;
  color: black;
  border: solid 1px var(--fit20-lighter-gray);
}

.field-sec.flex>label {
  width: 48%;
}

.field-sec.flex>input {
  width: fit-content;
}

.session-studio-container input.height {
  width: 60px !important;
  text-align: center;
}

.session-studio-container .fake-div {
  height: 88%;
}

.session-studio-container .close-popup {
  width: 30px;
  padding: 5px;
}

.remove-center {
  align-items: start;
}
</style>
